module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.activePanel) ? _c('div', {
    staticClass: "sideways-content-fold"
  }, [_c('div', {
    staticClass: "portlet light bordered"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "portlet-body portlet-overflow"
  }, [_c('form', {
    attrs: {
      "role": "form",
      "novalidate": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.createFolder($event)
      }
    }
  }, [(_vm.errorMessage.length) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "data-close": "alert"
    },
    on: {
      "click": function($event) {
        _vm.clearError()
      }
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.errorMessage))])]) : _vm._e(), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', [_c('div', {
    staticClass: "form-body invite-user-form"
  }, [_c('div', {
    staticClass: "form-group form-md-line-input form-md-floating-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.newFolder.name),
      expression: "newFolder.name",
      modifiers: {
        "trim": true
      }
    }],
    staticClass: "form-control input-sm",
    class: {
      'edited': _vm.newFolder.name.length
    },
    attrs: {
      "type": "text",
      "id": "create_folder_name",
      "maxlength": "255"
    },
    domProps: {
      "value": (_vm.newFolder.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.newFolder, "name", $event.target.value.trim())
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "create_folder_name"
    }
  }, [_vm._v("Folder Name")])]), _vm._v(" "), (!_vm.activeLocationId) ? _c('div', {
    staticClass: "form-md-checkboxes margin-bottom-20"
  }, [_c('div', {
    staticClass: "md-checkbox-inline"
  }, [_c('div', {
    staticClass: "md-checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.newFolder.is_shared),
      expression: "newFolder.is_shared"
    }],
    staticClass: "md-check",
    attrs: {
      "type": "checkbox",
      "id": "checkbox-privatize"
    },
    domProps: {
      "checked": Array.isArray(_vm.newFolder.is_shared) ? _vm._i(_vm.newFolder.is_shared, null) > -1 : (_vm.newFolder.is_shared)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.newFolder.is_shared,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.newFolder.is_shared = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.newFolder.is_shared = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.$set(_vm.newFolder, "is_shared", $$c)
        }
      }
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "checkbox-privatize"
    }
  }, [_c('span'), _vm._v(" "), _c('span', {
    staticClass: "check"
  }), _vm._v(" "), _c('span', {
    staticClass: "box"
  }), _vm._v("\n\t\t                        \t\t\t\tMake this folder "), _c('b', [_vm._v("public")]), _vm._v(" to all locations.\n\t\t                        \t\t\t")])])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "form-actions noborder invite-user-actions"
  }, [_c('button', {
    staticClass: "btn btn-default exit-invitation-setup",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.closePanel()
      }
    }
  }, [_vm._v(" Return To Resources Dashboard")]), _vm._v(" "), _c('button', {
    key: "create-folder-confirm",
    staticClass: "btn blue",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")])])])])], 1)])])]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "portlet-title"
  }, [_c('div', {
    staticClass: "caption"
  }, [_vm._v("\n\t\t\t\t\tCreate A Folder\n\t\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0245c56!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/app/Resources/CreateFolder.vue
// module id = 461
// module chunks = 1